import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useNavState } from '@/common/navState/NavStateContext';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const IncCondList = ({ incRuleId }) => {
  const { navState } = useNavState();

  const augRowsReq = useCallback(EntityUtils.parentFilterAugRowsReq('INC_RULE', incRuleId || navState.incRuleId), [
    incRuleId || navState.incRuleId,
  ]);

  return <EntityList entity="INC_COND" augRowsReq={augRowsReq} />;
};